import { motion } from "framer-motion";
import { SACRAMENTS, IMAGES } from "@/data/content";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

export default function Faith() {
  return (
    <section id="fe-e-sacramentos" className="relative bg-[#F4EFE6] px-4 sm:px-8 lg:px-16 py-20 lg:py-32 overflow-hidden">
      <img src={IMAGES.crucifix} alt="" aria-hidden="true" loading="lazy" className="absolute right-0 top-0 h-full w-1/3 object-cover opacity-[0.07] pointer-events-none" />
      <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce} className="relative">
        <motion.p variants={fadeUp} className="overline-label text-[#4A0E17]/60">Fé e Sacramentos</motion.p>
        <motion.h2 variants={fadeUp} className="font-display mt-4 max-w-3xl text-4xl sm:text-5xl font-bold uppercase leading-tight text-[#1C1917]">
          Os Sete Sacramentos da Igreja
        </motion.h2>
        <motion.p variants={fadeUp} className="font-liturgy mt-6 max-w-2xl text-xl italic text-[#4A0E17]/80">
          Sinais visíveis da graça invisível de Deus, instituídos por Cristo e confiados à sua Igreja.
        </motion.p>

        <div className="mt-14 grid md:grid-cols-2 gap-x-16">
          {SACRAMENTS.map((s) => (
            <motion.div
              key={s.numeral}
              variants={fadeUp}
              data-testid={`sacrament-${s.numeral}`}
              className="flex gap-6 py-6 border-b border-[#E5DEC9] items-baseline"
            >
              <span className="font-display text-2xl font-bold text-[#C5A059] w-10 shrink-0">{s.numeral}</span>
              <div>
                <h3 className="font-display text-lg font-bold text-[#1C1917]">{s.name}</h3>
                <p className="mt-1 text-sm text-[#1C1917]/60">{s.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
